/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import coupon2 from '../../assets/images/coupon2.png';
import truck from '../../assets/images/icon/icon-truck.png';
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from 'react-redux';
import { SearchPrizeById, UpdatePrize } from "../../services/Prize";
import { setMember } from "../../features/MemberSlice";
import prizeDefault from '../../assets/images/haier-prize-default-sq.png';
import CustomPopup from "../../components/popup/CustomPopup";
import useWindowDimensions from "../../functions/getScreen";


export default function PrizeDetail() {

    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const store = useSelector((state) => state.member)
    const [prizeDetail, setPrizeDetail] = React.useState(null);
    const { height } = useWindowDimensions();

    const [openAddressPopup, setOpenAddressPopup] = React.useState(false);

    React.useEffect(() => {
        getSearchPrizeById();
    }, []);

    async function getSearchPrizeById() {
        return await SearchPrizeById(state)
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setPrizeDetail(response.data.body)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }



    async function submitData() {
        if (prizeDetail.fullDeAddress) {
            navigate('/prize-address', { state: prizeDetail })
            // await postUpdatePrize()
        } else {
            setOpenAddressPopup(true)
        }

    }

    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setMember(tmpObj));
    }

    return (
        <>
            <TopLogo />
            {prizeDetail &&
                <div
                    style={{
                        background: "#005AAA",
                        paddingTop: "20px"
                    }}
                >
                    <div className="overflow-y-auto px-[20px]" style={{ height: `${height - 176}px` }}>
                        <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">

                            <div className="text-center">
                                <p className="text-blue text-[24px] leading-[20px]">{prizeDetail.name}</p>
                                <p className="text-darkGray text-[20px]">รับได้ถึงวันที่: {dayjs(prizeDetail.expireDate, 'YYYY-MM-DD HH:mm:ss').add(7, 'hours').format('DD/MM/YYYY')}</p>
                            </div>

                            <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />

                            {prizeDetail.picture ? (
                                <img
                                    className="mx-auto mt-[10px]"
                                    src={prizeDetail.picture}
                                    alt="logo"
                                    style={{ width: "170px" }}
                                />
                            ) : (
                                <img
                                    className="mx-auto mt-[10px]"
                                    src={prizeDefault}
                                    alt="logo"
                                    style={{ width: "170px" }}
                                />
                            )
                            }

                            <div className="w-[80px] h-[30px] pt-[5px] mx-auto mt-[20px] bg-lightBlue2" style={{ borderRadius: '5px' }}>
                                <div className="flex gap-[5px] mx-auto w-fit">
                                    <img
                                        src={truck}
                                        alt="logo"
                                        style={{ height: '19px' }}
                                    />
                                    <p className="text-white text-[15px]">จัดส่งฟรี!</p>
                                </div>
                            </div>

                            <hr className="border-b-1px border-lightGray w-full mt-[20px] mb-[20px]" />

                            <div className="text-center">
                                <p className="text-blue text-[20px] leading-[20px]">เงื่อนไขการรับของรางวัล</p>
                            </div>
                            <div className="whitespace-pre-line mx-[30px]">
                                {prizeDetail.conditions}
                            </div>
                            <br></br>
                        </div>

                    </div>
                </div>}
            <div className="bg-white h-[100px] pt-[25px]">
                <Stack
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                >
                    <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => navigate(-1)}>
                        ยกเลิก
                    </SecondaryButton>
                    <PrimaryButton variant="contained" className="w-[40%]" onClick={() => submitData()}>
                        รับรางวัล
                    </PrimaryButton>
                </Stack>
            </div>

            <CustomPopup
                title={"คุณยังไม่ได้เพิ่มที่อยู่"}
                desc={"กรุณากรอกข้อมูลที่อยู่ของคุณ\nเพื่อรับของรางวัลพิเศษ"}
                actionText={'กรอกข้อมูลที่อยู่'}
                actionFunction={() => {
                    setOpenAddressPopup(false);
                    navigate('/prize-address', { state: prizeDetail })
                }}
                open={openAddressPopup}
            />
        </>
    );
}
